
  import { defineComponent, onMounted, ref, computed, onUnmounted } from 'vue';
  import { ErrorMessage, Field, Form } from 'vee-validate';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import * as Yup from 'yup';
  import { RegisteredTradeScrapingObject } from '@/store/modules/RegisteredTrades/RegisteredTradesScrapingModule';
  import Multiselect from '@vueform/multiselect';
  import { StatusNotesMap } from '../registered-trades/status-notes.enum';
  import { TradeStatusMap } from '../registered-trades/status-map.enum';

  export default defineComponent({
    name: 'registered-trades-scraping-editing',
    components: {
      ErrorMessage,
      Field,
      Form,
      Multiselect,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const route = useRoute();
      const { can } = useAbility();
      const submitButton = ref<HTMLButtonElement | null>(null);
      const submitButtonBlock = ref<HTMLButtonElement | null>(null);
      const showBlocksListButton = ref<HTMLButtonElement | null>(null);
      const showOriginalTradeButton = ref<HTMLButtonElement | null>(null);
      const descriptionAr = ref('');
      const descriptionEn = ref('');
      const notesEn = ref('');
      const notesAr = ref('');
      const selectedNote = ref<number>(0);
      selectedNote.value = 23;
      const cloneShow = ref(false);
      const showFloatingText = ref(false);
      const cloneCount = ref(0);
      const statusNotesId = ref(0);
      const status = ref(1);
      const statusMap = TradeStatusMap;
      const statusNoteMap = StatusNotesMap;
      const creatingClones = ref(false);
      const registeredTradeId = ref(0);
      const descriptionId = ref(0);

      onMounted(() => {
        window.addEventListener('scroll', handleScroll);
        setCurrentPageBreadcrumbs(translate('registeredTradesUpdating'), [
          translate('registeredTrades'),
        ]);
      });
      onUnmounted(() => {
        window.removeEventListener('scroll', handleScroll);
      });

      const handleScroll = () => {
        const bottomElement = document.querySelector('.card-footer');
        if (bottomElement) {
          // const rect = bottomElement.getBoundingClientRect();
          showFloatingText.value = true;
        }
      };

      // Scroll to bottom function
      const scrollToBottom = () => {
        const bottomElement = document.querySelector('.card-footer');
        if (bottomElement) {
          bottomElement.scrollIntoView({ behavior: 'smooth' });
        }
      };

      const showBlocksList = (id) => {
        // router.push({
        //   name: 'registered-trades-blocks-listing',
        //   params: { id },
        // });
        const url = router.resolve({
          name: 'registered-trades-blocks-listing',
          params: { id },
        }).href;

        window.open(url, '_blank');
      };

      const showOriginalTrade = (id) => {
        // router.push({
        //   name: 'registered-trades-editing',
        //   params: { id },
        // });

        const url = router.resolve({
          name: 'registered-trades-editing',
          params: { id },
        }).href;

        window.open(url, '_blank');
      };

      await store.dispatch(Actions.GET_ALL_AREAS_LIST, {
        type: 'registeredTrades',
      });
      const selectedArea = ref<number>(0);
      const selectedPropertyType = ref<number>(0);
      // await store.dispatch(Actions.GET_ALL_PROPERTY_TYPES);
      const { data } = await store.dispatch(
        Actions.GET_REGISTERED_TRADE_SCRAPING,
        route.params.id
      );

      const updatePricePerSqrM = async () => {
        if (
          registeredTrade.value &&
          registeredTrade.value.size &&
          registeredTrade.value.salePrice
        ) {
          registeredTrade.value.pricePerM2 = Number(
            (
              Number(registeredTrade.value.salePrice) /
              Number(registeredTrade.value.size)
            ).toFixed(2)
          );
        }
      };

      const registeredTrade = ref<RegisteredTradeScrapingObject>(data.data);
      const translate = (text: string) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      const goBack = () => {
        router.back();
      };

      const registeredTradeSchema = Yup.object().shape({
        // transactionDate: Yup.date()
        //   .required(() => translate('TRANSACTION_DATE_IS_REQUIRED_FIELD'))
        //   .label('transactionDate'),
        // transactionNumber: Yup.number()
        //   .required(() => translate('TRANSACTION_NUMBER_IS_REQUIRED_FIELD'))
        //   .label('transactionNumber'),
        // selectedArea: Yup.mixed().test(
        //   'is-area-selected',
        //   'Please select an area',
        //   function () {
        //     debugger;
        //     return this.parent.selectedArea !== null;
        //   }
        // ),
        size: Yup.number()
          .required(() => translate('SIZE_IS_REQUIRED_FIELD'))
          .label('size'),
        status: Yup.number()
          .required(() => translate('STATUS_IS_REQUIRED_FIELD'))
          .label('status'),
        percentage: Yup.string()
          .required(() => translate('PERCENTAGE_IS_REQUIRED_FIELD'))
          .label('Percentage'),
        // price: Yup.number()
        //   .required(() => translate('PRICE_IS_REQUIRED_FIELD'))
        //   .label('price'),
        pricePerM2: Yup.number()
          .required(() => translate('PRICE_PER_M2_IS_REQUIRED_FIELD'))
          .label('pricePerM2'),
        // areaId: Yup.number()
        //   .required(() => translate('AREA_IS_REQUIRED_FIELD'))
        //   .label('areaId'),
        // propertyTypeId: Yup.number()
        //   .required(() => translate('PROPERTY_TYPE_IS_REQUIRED_FIELD'))
        //   .label('propertyTypeId'),
      });

      const updateDesc = async (values) => {
        debugger;
        const selectedDesc = registeredDescs.value.find(
          (desc) => desc.id == values
        );
        descriptionId.value = Number(selectedDesc?.id);
        descriptionAr.value = selectedDesc?.titleAr;
        descriptionEn.value = selectedDesc?.titleEn;
      };

      const updateNotes = async (values) => {
        debugger;
        const selectedNotes = registeredNotes.value.find(
          (desc) => desc.id == values
        );
        notesAr.value = selectedNotes?.titleAr;
        notesEn.value = selectedNotes?.titleEn;
      };

      const onSubmitUpdate = async (values) => {
        if (selectedArea.value == 0 || selectedPropertyType.value == 0) return;
        if (submitButton.value) {
          // eslint-disable-next-line
          submitButton.value!.disabled = true;
          submitButton.value.setAttribute('data-kt-indicator', 'on');
        }

        if (descriptionId.value) {
          values.descriptionId = descriptionId.value;
        }

        values.id = registeredTrade.value?.id;
        values.areaId = selectedArea.value;
        values.propertyTypeId = selectedPropertyType.value;
        delete values.description;
        delete values.notes;

        if (values.price) {
          const numericValue = values.price.replace(/[^0-9.]/g, '');
          values.price = Number(numericValue);
        }

        if (status.value) values.status = status.value;

        if (statusNotesId.value) values.statusNotesId = statusNotesId.value;

        if (status.value === 1) {
          values.statusNotesId = null;
        }

        const trade = await store.dispatch(
          Actions.CREATE_REGISTERED_TRADE_SCRAPING,
          values
        );
        const [errorName] = Object.keys(store.getters.getErrors);
        const error = store.getters.getErrors[errorName];

        if (error) {
          Swal.fire({
            text: translate(error[0]),
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: translate('tryAgainExcl'),
            customClass: {
              confirmButton: 'btn fw-bold btn-light-danger',
            },
          });
          //Deactivate indicator
          submitButton.value?.removeAttribute('data-kt-indicator');
          // eslint-disable-next-line
          submitButton.value!.disabled = false;
        } else {
          Swal.fire({
            text: translate('SUCCESSFULLY_UPDATED_REGISTERED_TRADE_SCRAPING'),
            icon: 'success',
            buttonsStyling: false,
            confirmButtonText: translate('ok'),
            customClass: {
              confirmButton: 'btn btn-light-primary',
            },
          }).then(() => {
            if (registeredTrade.value.duplicates === 0)
              router.push({ name: 'registered-trades-scraping-listing' });

            if (trade.data.id) {
              registeredTradeId.value = trade.data.id;

              cloneCount.value++;
              cloneShow.value = true;
              //Deactivate indicator
              submitButton.value?.removeAttribute('data-kt-indicator');
              // eslint-disable-next-line
              submitButton.value!.disabled = false;
            }
          });
        }
      };
      store.dispatch(Actions.GET_ALL_AREAS_LIST, {
        type: 'registeredTrades',
      });
      store.dispatch(Actions.GET_ALL_PROPERTY_TYPE, {
        type: 'registeredTrades',
      });
      await store.dispatch(Actions.GET_REGISTERED_TRADES_ASSETS, 6); //we should enum these
      await store.dispatch(Actions.GET_REGISTERED_TRADES_ASSETS, 7);
      const registeredNotes = computed(() => store.getters.getRegisteredNotes);

      updateNotes(23);

      const createBlocksCopy = async () => {
        if (!registeredTradeId.value || registeredTradeId.value === 0) {
          Swal.fire({
            text: translate('PLEASE_SAVE_BEFORE_CREATING_CLONES'),
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: translate('tryAgainExcl'),
            customClass: {
              confirmButton: 'btn fw-bold btn-light-danger',
            },
          });
        }

        if (submitButtonBlock.value) {
          // eslint-disable-next-line
          submitButtonBlock.value!.disabled = true;
          submitButtonBlock.value.setAttribute('data-kt-indicator', 'on');
        }
        creatingClones.value = true;
        try {
          await store.dispatch(Actions.CREATE_REGISTERED_TRADE_CLONE, {
            id: registeredTradeId.value,
            cloneAmount: registeredTrade.value.duplicates,
            scrapingId: registeredTrade.value.id,
            action: 2, //1 mean create
            registeredTradeClonedId:
              registeredTrade.value.registeredTradeClonedId,
            size: registeredTrade.value.size,
            pricePerM2: registeredTrade.value.pricePerM2,
            numberOfCloned: registeredTrade.value.numberOfCloned,
          });
          const [errorName] = Object.keys(store.getters.getErrors);
          const error = store.getters.getErrors[errorName];
          if (error) {
            Swal.fire({
              text: translate(error[0]),
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: translate('tryAgainExcl'),
              customClass: {
                confirmButton: 'btn fw-bold btn-light-danger',
              },
            });
            submitButtonBlock.value?.removeAttribute('data-kt-indicator');
            // eslint-disable-next-line
            submitButtonBlock.value!.disabled = false;
          } else {
            Swal.fire({
              text: translate('SUCCESSFULLY_CLONED_REGISTERED_TRADE_SCRAPING'),
              icon: 'success',
              buttonsStyling: false,
              confirmButtonText: translate('ok'),
              customClass: {
                confirmButton: 'btn btn-light-primary',
              },
            }).then(() => {
              submitButtonBlock.value?.removeAttribute('data-kt-indicator');
              // eslint-disable-next-line
              submitButtonBlock.value!.disabled = false;
            });
          }
        } catch (error) {
          console.error('Error creating clones:', error);
          // Handle error
        } finally {
          creatingClones.value = false;
        }
      };

      const createClones = async () => {
        if (!registeredTradeId.value || registeredTradeId.value === 0) {
          Swal.fire({
            text: translate('PLEASE_SAVE_BEFORE_CREATING_CLONES'),
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: translate('tryAgainExcl'),
            customClass: {
              confirmButton: 'btn fw-bold btn-light-danger',
            },
          });
        }

        if (submitButtonBlock.value) {
          // eslint-disable-next-line
          submitButtonBlock.value!.disabled = true;
          submitButtonBlock.value.setAttribute('data-kt-indicator', 'on');
        }
        creatingClones.value = true;
        try {
          await store.dispatch(Actions.CREATE_REGISTERED_TRADE_CLONE, {
            id: registeredTradeId.value,
            cloneAmount: registeredTrade.value.duplicates,
            scrapingId: registeredTrade.value.id,
            action: 1, //1 mean create
            registeredTradeClonedId: -1,
          });
          const [errorName] = Object.keys(store.getters.getErrors);
          const error = store.getters.getErrors[errorName];
          if (error) {
            Swal.fire({
              text: translate(error[0]),
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: translate('tryAgainExcl'),
              customClass: {
                confirmButton: 'btn fw-bold btn-light-danger',
              },
            });
            submitButtonBlock.value?.removeAttribute('data-kt-indicator');
            // eslint-disable-next-line
            submitButtonBlock.value!.disabled = false;
          } else {
            Swal.fire({
              text: translate('SUCCESSFULLY_CLONED_REGISTERED_TRADE_SCRAPING'),
              icon: 'success',
              buttonsStyling: false,
              confirmButtonText: translate('ok'),
              customClass: {
                confirmButton: 'btn btn-light-primary',
              },
            }).then(() => {
              submitButtonBlock.value?.removeAttribute('data-kt-indicator');
              // eslint-disable-next-line
              submitButtonBlock.value!.disabled = false;
            });
          }
        } catch (error) {
          console.error('Error creating clones:', error);
          // Handle error
        } finally {
          creatingClones.value = false;
        }
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');
      const registeredDescs = computed(() => store.getters.getRegisteredDesc);
      const formattedPrice = computed({
        get() {
          // Format the raw price as a string with commas (e.g., 10,000)
          debugger;
          const wPrice = Number(registeredTrade.value.salePrice);
          return wPrice.toLocaleString();
        },
        set(value: string) {
          // Remove non-numeric characters (e.g., commas) and update the raw price
          const numericValue = value.replace(/[^0-9.]/g, '');
          registeredTrade.value.salePrice = numericValue;
        },
      });
      return {
        formattedPrice,
        updatePricePerSqrM,
        selectedNote,
        notesAr,
        notesEn,
        descriptionId,
        descriptionAr,
        descriptionEn,
        updateNotes,
        updateDesc,
        registeredDescs,
        registeredNotes,
        areas: computed(() => store.getters.allListAreas),
        propertyTypes: computed(() => store.getters.propertyTypesAllList),
        onSubmitUpdate,
        submitButton,
        submitButtonBlock,
        translate,
        registeredTradeSchema,
        goBack,
        registeredTrade,
        can,
        selectedArea,
        selectedPropertyType,
        cloneShow,
        showFloatingText,
        scrollToBottom,
        cloneCount,
        statusMap,
        statusNoteMap,
        status,
        statusNotesId,
        createClones,
        creatingClones,
        showBlocksList,
        showOriginalTrade,
        registeredTradeId,
        showBlocksListButton,
        showOriginalTradeButton,
        createBlocksCopy,
      };
    },
  });
